import React from 'react'

export const CategorySelectGroupTitle = ({ children }) => (
  <label className="text-md text-darkBlack mb-1 font-semibold block">{children}</label>
)
